import React from 'react';
import { CardContent, Typography, Button, CardMedia, Link, Grid, Box } from '@mui/material';

const PublicationItem = ({ publication }) => {
  const { title, authors, journal, date, summary, imageUrl, fullTextUrl, doiUrl } = publication;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Grid container>
        {imageUrl && (
          <Grid item xs={12} sm={3}>
            <CardMedia
              component="img"
              image={imageUrl}
              alt="Publication cover"
              sx={{ width: '100%', height: 'auto', padding: 2 }}
            />
          </Grid>
        )}
        <Grid item xs={12} sm={imageUrl ? 9 : 12}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              <Link href={doiUrl || fullTextUrl} underline="hover" color="inherit" target="_blank">
                {title}
              </Link>
            </Typography>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {authors}
            </Typography>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {journal}{journal.includes(date) ? "" : ", " + date}
            </Typography>
            <Typography align='left' paragraph>
              {summary}
            </Typography>
            <Button variant="outlined" size="small" href={fullTextUrl} target="_blank">Zur Veröffentlichung</Button>
            {doiUrl && <Button variant="outlined" size="small" href={doiUrl} target="_blank" sx={{ ml: 1 }}>DOI</Button>}
          </CardContent>
        </Grid>
      </Grid>
      <Box sx={{height: 2, width: "100%", bgcolor: "black"}}/>
    </Box>
  );
};

export default PublicationItem;
